import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateStokeCodelist(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
  },
  actions: {
    updateStokeCodelist({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('EMHqApi.getStokeCodelist', id)
          .then((json) => {
            // console.log(`zxy----getStokeCodelist---${JSON.stringify(json)}`);
            commit('updateStokeCodelist', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
